import Vue from 'vue'
import {dd,store,app} from 'systems/imports'

import queryString from 'query-string'
import DetectBrowserLanguage from 'utils/DetectBrowserLanguage'
import BaseProcessor from 'processor/BaseProcessor'
import API from 'api/AppTranslation'

/**
 * 運営サイト情報
 */
class AppTranslation extends BaseProcessor{
  static getClassName(){ return 'AppTranslation' }

  static isInitialized = false;

  /**
   */
  static refresh(){
    //URLクエリがある場合は初期値を変更
    if(!AppTranslation.isInitialized){
      let query = queryString.parse(location.search)
      if(query.lang){
        store.set("i18n",query.lang)
      }
      AppTranslation.isInitialized = true
    }

    let i18n = store.get("i18n") || (()=>{
        let usePrefixOnly = ['ja','en']
        let availableLocate = ['ja','en', 'zh-cn','zh-tw']
        let value = DetectBrowserLanguage.locate.toLowerCase()
        if(app.make("_").includes(usePrefixOnly, value.substr(0, 2))){
          value = value.substr(0, 2)
        }
        if(!app.make("_").includes(availableLocate, value)){
          value = 'en'
        }
        store.set("i18n",value)
        return value
      })()

    app.make("axios").defaults.headers.common['APPLICATION-LANGUAGE'] = i18n
    if (!Vue.locale(i18n)) {
      Vue.locale(i18n, () => {
        return API.get(i18n)
          .then(({ui,error}) => {
            return {ui, error}
          })
      }, () => {
        Vue.config.lang = null
        Vue.config.lang = i18n
      })
    }
    Vue.config.lang = i18n
  }
  static setLang(langCode){
    store.set("i18n",langCode)
    AppTranslation.refresh()
  }
}

export default AppTranslation



// WEBPACK FOOTER //
// ./src/processor/AppTranslation.js